module.exports = __webpack_public_path__ + "static/img/carousel_3_optyeh_ar_16_9_w_768.3556f3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_3_optyeh_ar_16_9_w_768.jpg
// module id = 3gin
// module chunks = 0